module.exports = __webpack_public_path__ + "img/chevron-down.1e879368.svg";